module.exports = {"TXTACL_My_Bets":{"id":"TXTACL_My_Bets","defaultMessage":"Fogadásaim"}}